import { memo } from 'react'
import { AlertTriangle } from 'lucide-react'

interface StyleCreatorErrorProps {
  message: string
  onRetry: () => void
}

const StyleCreatorError = memo(({ message, onRetry }: StyleCreatorErrorProps) => (
  <div className="mx-6 mt-4 p-4 rounded-lg bg-amber-500/10 border border-amber-500/30">
    <div className="flex items-start gap-3">
      <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-foreground">
          Style generation failed.
        </h3>
        <p className="text-sm text-foreground/60 mt-1">
          {message}
        </p>
        <button
          onClick={onRetry}
          className="mt-3 px-4 py-1.5 rounded-lg text-sm font-medium
            bg-amber-500/20 text-amber-300 border border-amber-500/30
            hover:bg-amber-500/30 hover:text-amber-200
            transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  </div>
))

StyleCreatorError.displayName = 'StyleCreatorError'
export { StyleCreatorError }
